import dxDataGrid from 'devextreme/ui/data_grid';

export function getDataSourceFilteredAndSortedData(dxDataGrid: dxDataGrid, result: (data: any) => void, selectedRowsOnly: boolean = false): void {
	let filterExpr = dxDataGrid?.getCombinedFilter(true);
	const dataSource = dxDataGrid?.getDataSource();
	const loadOptions = dataSource?.loadOptions();

	if (selectedRowsOnly) {
		result(dxDataGrid.getSelectedRowsData());
	} else {
		dataSource?.store().load(
			{
				filter: filterExpr,
				sort: loadOptions?.sort,
				group: loadOptions?.group,
			}
		).then(result);
	}
}
